import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManagementRoutingModule } from './management-routing.module';
import { SideNavService } from 'src/app/shared/side-nav/services/side-nav.service';
import { managementSideNavConfig } from './management-sidenav.config';
import {ConfirmationPopupModule} from "../../kernel/popups/popup/modules/confirmation-dialog/confirmation-popup.module";
import { BlacklistUserPopupComponent } from './components/blacklist-user-popup/blacklist-user-popup.component';
import {UserService} from "./services/user.service";
import {UserApiService} from "./services/user-api.service";
import {ButtonModule} from "../../kernel/shared/modules/button/button.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {SimpleInputsModule} from "../../kernel/form/modules/inputs/simple-inputs/simple-inputs.module";
import {SvgIconModule} from "../../kernel/tools/svg-icon/svg-icon.module";

@NgModule({
  declarations: [


    BlacklistUserPopupComponent
  ],
  imports: [
    CommonModule,
    ManagementRoutingModule,
    ConfirmationPopupModule,
    ButtonModule,
    FormsModule,
    ReactiveFormsModule,
    SimpleInputsModule,
    SvgIconModule
  ],
  providers: [
    UserService,
    UserApiService
  ]
})
export class ManagementModule {
   constructor(sideNavService: SideNavService) {
    sideNavService.addSubMenuItems('management', managementSideNavConfig)
  }
 }
